/**
* DO NOT EDIT MANUALLY
* This is an auto-generated file.
* Any changes will be overwritten.
*/
var e=e=>{let t=new URLSearchParams;e.q&&t.set(`q`,e.q),e.make&&t.set(`make`,e.make),e.model&&t.set(`model`,e.model),e.dept&&t.set(`dept`,e.dept);let n=t.toString();return n?`/search?${n}`:`/search`};export{e as buildSearchUrl};